import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '@redux/hooks';
import { SkeletonLoading } from '@app/shared';
import { CategoryQuestion } from '../../module/types/questionsSchema';
import { getActiveQuestion } from '../../module/selectors/getActiveQuestion';
import { getQuestions, getIsLoaded } from '../../module/selectors/getQuestions';
import { GetQuestion } from '../../module/services/GetQuestion';
import classNames from 'classnames';
import IconArrow from './icons/arrow.svg';

import styles from './AccordionQuestion.module.scss';

export const AccordionQuestions = ({ typeId }: { typeId: CategoryQuestion }) => {
  const dispatch = useAppDispatch();
  const questions = useAppSelector(getQuestions);
  const activeQuestion = useAppSelector(getActiveQuestion);
  const isLoaded = useAppSelector(getIsLoaded);
  const [activeAccordions, setActiveAccordions] = useState<number[]>([]);

  useEffect(() => {
    if (!isLoaded) {
      dispatch(GetQuestion({ typeId }));
    }
  }, []);

  useEffect(() => {
    if (activeQuestion || activeQuestion === 0) {
      handlerShowAccordion(activeQuestion);
    }
  }, [activeQuestion]);

  const handlerShowAccordion = (index: number): void => {
    if (activeAccordions.some(x => x === index)) {
      setActiveAccordions(prevState => prevState.filter(x => x !== index));
    } else {
      setActiveAccordions([...activeAccordions, index]);
    }
  };

  if (questions.length === 0) {
    return null;
  }

  if (!isLoaded) {
    return (
      <div className={styles.Wrapper}>
        <SkeletonLoading width={'100%'} height={'40vh'} />
      </div>
    );
  }

  return (
    <div className={styles.Wrapper}>
      {questions.map((item, index) => (
        <div
          onClick={() => handlerShowAccordion(index)}
          className={classNames(styles.Item, { [styles.Open]: activeAccordions.includes(index) })}
          key={item.title}
        >
          <div className={styles.Header}>
            <div className={styles.Title}>{item.title}</div>
            <IconArrow />
          </div>
          <div className={styles.Text} dangerouslySetInnerHTML={{ __html: item.text }} />
        </div>
      ))}
    </div>
  );
};
